import { createAction } from '@reduxjs/toolkit'

import { SupportMessagePayload } from './supportDomain'

export const sendSupportMessage = createAction<SupportMessagePayload>("POST_SUPPORT_MESSAGE_SAGA")
